import { IInventoryFormValues } from './inventoryFormValues';
import { z } from 'zod';
import { baseModelSchema } from '../../baseModel';

/**
 * Zod schema for validating inventory data.
 * Extends the base model schema with inventory-specific fields.
 *
 * @property {string} code - Unique identifier code (max 2 characters)
 * @property {string} description - Description of the inventory (max 255 characters)
 */
export const inventorySchema = baseModelSchema.extend({
    code: z.string().nonempty('Code is required').max(2, 'Code can only be up to 2 characters long.').default(''),
    description: z.string().nonempty('Description is required').max(255, 'Description can only be up to 255 characters long.').default(''),
});

/**
 * TypeScript interface representing an Inventory object.
 * Generated from the Zod schema for type safety.
 */
export type IInventory = z.infer<typeof inventorySchema>;

// Convert form values into a valid inventory object
export function Inventory(formValues : IInventoryFormValues) : IInventory {
    return inventorySchema.parse({
        ...formValues,
    });
};
